import config from '../config';
import readXLSXFromUrl from '@common/xlsxExport/utils/readXLSXFromUrl';
import downloadXlsxFile from '../shared/xlsxExport/downloadXlsxFile';
import { generateAssetPath } from '../utils/assetsHelpers';
import { formatWorkbook } from '@common/xlsxExport/utils/formatWorkbook';

const generateTemplateRow = ({ period, companyCode, functionalCurrency } = {}) =>
  [period, companyCode, null, functionalCurrency];

export const downloadTrialBalanceTemplate = async props => {
  const {
    period,
    companyCode,
    functionalCurrency,
    environmentSuffix,
  } = props;

  const url = generateAssetPath(config.templates.TRIAL_BALANCE);

  const template = await readXLSXFromUrl(url);

  const additionalRow = generateTemplateRow({
    period,
    companyCode,
    functionalCurrency,
  });

  const formattedSheets = formatWorkbook(template);

  formattedSheets[0].grid = formattedSheets[0].grid.concat([additionalRow]);

  downloadXlsxFile(`TLS_Trial_Balance_${period}_${companyCode}${environmentSuffix}`, formattedSheets);
};
